import { render, staticRenderFns } from "./1022.vue?vue&type=template&id=6455b6dc&scoped=true&"
import script from "./1022.vue?vue&type=script&lang=js&"
export * from "./1022.vue?vue&type=script&lang=js&"
import style0 from "./1022.vue?vue&type=style&index=0&id=6455b6dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6455b6dc",
  null
  
)

export default component.exports